module.exports = __webpack_public_path__ + "static/media/White-background-logo.de75de34.png";